export default function usePercentInput(setPercent:Function){

  function onChange(value:string) {
    if (value.match(/^[0-9]{0,3}$/) || !value) {
      setPercent(parseInt(value) || '');
    }
  }

  return {onChange};
}